import { EVENTS } from './events';

const CONVERSION_EVENTS = {
  view_projects: {
    sourceEvent: EVENTS.SECTION_VIEW,
    match: (params) => params.section_id === 'projects',
  },
  view_contact: {
    sourceEvent: EVENTS.SECTION_VIEW,
    match: (params) => params.section_id === 'contact',
  },
  funnel_complete: {
    sourceEvent: EVENTS.FUNNEL_COMPLETE,
    match: () => true,
  },
  project_card_click: {
    sourceEvent: EVENTS.PROJECT_CARD_CLICK,
    match: () => true,
  },
  project_modal_open: {
    sourceEvent: EVENTS.PROJECT_MODAL_OPEN,
    match: () => true,
  },
  project_outbound_click: {
    sourceEvent: EVENTS.PROJECT_LINK_CLICK,
    match: (params) => params.link_type === 'external',
  },
  about_outbound_click: {
    sourceEvent: EVENTS.ELEMENT_CLICK,
    match: (params) =>
      params.section_id === 'about' && params.link_type === 'external',
  },
  resume_download: {
    sourceEvent: EVENTS.CONTACT_LINK_CLICK,
    match: (params) => params.link_type === 'resume',
  },
  contact_email_click: {
    sourceEvent: EVENTS.CONTACT_LINK_CLICK,
    match: (params) => params.link_type === 'email',
  },
  scroll_depth_75: {
    sourceEvent: EVENTS.SCROLL_DEPTH,
    match: (params) => params.depth_percent >= 75,
  },
};

const firedConversions = new Set();

export function getMatchingConversions(eventName, params = {}) {
  const matches = [];

  Object.entries(CONVERSION_EVENTS).forEach(([conversionName, config]) => {
    if (config.sourceEvent !== eventName || !config.match(params)) {
      return;
    }

    const dedupeKey = `${conversionName}:${eventName}:${JSON.stringify(params)}`;
    if (firedConversions.has(dedupeKey)) {
      return;
    }

    firedConversions.add(dedupeKey);
    matches.push(conversionName);
  });

  return matches;
}

export const GA4_CONVERSION_SETUP = [
  {
    event: 'view_projects',
    description: 'User viewed the Projects section.',
  },
  {
    event: 'view_contact',
    description: 'User viewed the Contact section.',
  },
  {
    event: 'funnel_complete',
    description: 'User reached Contact in the home → about → projects → contact funnel.',
  },
  {
    event: 'project_card_click',
    description: 'User clicked a portfolio project card.',
  },
  {
    event: 'project_modal_open',
    description: 'User opened a project detail modal.',
  },
  {
    event: 'project_outbound_click',
    description: 'User clicked an external project link (demo, GitHub, Steam, etc.).',
  },
  {
    event: 'about_outbound_click',
    description: 'User clicked an external link in the About section.',
  },
  {
    event: 'resume_download',
    description: 'User clicked the PDF resume link.',
  },
  {
    event: 'contact_email_click',
    description: 'User clicked the mailto email link.',
  },
  {
    event: 'scroll_depth_75',
    description: 'User scrolled at least 75% down the page.',
  },
];
